









import {
  defineComponent,
  computed, onMounted,
} from '@nuxtjs/composition-api';
import { usePageStore } from '~/stores/page';

import CATEGORY from '~/modules/catalog/pages/category.vue';
import BRAND from '~/modules/catalog/pages/brand.vue';
import SEARCH from '~/modules/catalog/pages/search.vue';
import CMS_PAGE from '~/pages/Cms.vue';
import PRODUCT from '~/modules/catalog/pages/product.vue';
import {CacheTagPrefix} from "@vue-storefront/cache";

export default defineComponent({
  name: 'PageResolver',
  components: {
    CATEGORY,
    BRAND,
    SEARCH,
    CMS_PAGE,
    PRODUCT,
  },
  middleware: [
    'url-resolver',
  ],
  setup() {
    const { routeData } = usePageStore();

    //const type = computed(() => routeData?.type);
    const type = computed(() => routeData?.type).value == 'CMS_PAGE' ? computed(() => routeData?.identifier).value.includes("brand/") ? 'BRAND' : computed(() => routeData?.identifier).value.includes("ricerca") ? 'SEARCH' : computed(() => routeData?.type) : computed(() => routeData?.type);

    return {
      type,
    };
  },
});
